// SHARED

// Foundations
import { Injectable } from '@angular/core';

// rxjs
import { BehaviorSubject, combineLatest, Observable, forkJoin } from 'rxjs';
import { map, switchMap, take } from 'rxjs/operators';

// Models
import { FranchiseLocation } from '../models/franchise.model';

// Services
import { AuthService } from '../auth/auth.service';
import {
  GetPreferredLocationGQL,
  GetVisitedLocationsGQL,
} from './graphql.service';

// JSON
import PHONE_TYPES from 'src/assets/json/phone-types.json';

@Injectable({
  providedIn: 'root',
})
export class MyProfileService {
  // Phone Type properties
  phoneTypeList = PHONE_TYPES;

  // Camp Locations properties
  preferredLocation: FranchiseLocation = undefined;
  preferredLocation$ = new BehaviorSubject<FranchiseLocation>(
    this.preferredLocation
  );
  otherLocations: FranchiseLocation[] = [];
  otherLocations$ = new BehaviorSubject<FranchiseLocation[]>(
    this.otherLocations
  );
  locationList$ = new BehaviorSubject<FranchiseLocation[]>([]);

  // A temp location for "location search"
  newOptionFromSearch: FranchiseLocation;

  constructor(
    public authService: AuthService,
    public getPreferredLocationQuery: GetPreferredLocationGQL,
    public getVisitedLocationsQuery: GetVisitedLocationsGQL
  ) {}

  // Camp Locations
  fetchLocationList() {
    //
    const fetchPreferredLocation$ = this.authService.getCurrentAccountId().pipe(
      switchMap((accountId) => {
        return this.getPreferredLocationQuery.fetch({ accountId }).pipe(
          take(1),
          map((res) => res.data.getPreferredLocation)
        );
      })
    );

    const fetchOtherLocation$ = this.authService.getCurrentAccountId().pipe(
      switchMap((accountId) => {
        return this.getVisitedLocationsQuery.fetch({ accountId }).pipe(
          take(1),
          map((res) => res.data.getVisitedLocations)
        );
      })
    );

    forkJoin([fetchPreferredLocation$, fetchOtherLocation$])
      .pipe(
        take(1),
        map(([preferred, visitedList]) => {
          this.preferredLocation = preferred;
          this.preferredLocation$.next(this.preferredLocation);
          this.otherLocations = visitedList;
          this.otherLocations$.next(this.otherLocations);

          // Return a combined list
          return [preferred, ...visitedList];
        })
      )
      .subscribe((locationList) => this.locationList$.next(locationList));
  }

  // #region -> Utils - Location <-
  // ----------

  isCcpEnabled(location: FranchiseLocation): boolean {
    if (location) {
      return location.creditCardProcessingEnabled;
    }

    return false;
  }

  // ----------
  // #endregion

  // ///////////////////////////
}
